module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules05-4e9674c08c450535847c7d9a50eb56ff.png";